import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { editorAddField, editorRemoveField, editorToggleRequired } from '../../../../../../store/pages-management/actions'
import { MeetingPageField, MeetingPageFieldType } from '../../../../../../types/plann3r'
import CheckBox from '../../Common/CheckBox'
import { NumberField, RadioField, SelectField, TextField } from './Fields'
import { MeetingPageFieldsProps as Props } from './types'

const MeetingPageFields: FC<Props> = ({ strings, fields }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  /**
   * Returns the field content based on the given field
   * 
   * @param field 
   */
  const getFieldContent = (field: MeetingPageField) => {
    switch (field.type) {
      case MeetingPageFieldType.EMAIL:
      case MeetingPageFieldType.NAME:
      case MeetingPageFieldType.TEXT:
        return <TextField strings={ strings } field={ field } />

      case MeetingPageFieldType.NUMBER:
        return <NumberField strings={ strings } field={ field } />

      case MeetingPageFieldType.RADIO:
        return <RadioField strings={ strings } field={ field } />

      case MeetingPageFieldType.SELECT:
        return <SelectField strings={ strings } field={ field } />
    }
  }

  return (
    <div className="part fields">
      <div className="part_header">
        <h3 className="inline">{ strings.fields }</h3>
        <button
          className="button is-primary inline float-right"
          onClick={ () => dispatch(editorAddField(MeetingPageFieldType.TEXT)) }
        >
          <i className="fa fa-plus" />
          { ' ' + strings.add_field }
        </button>

        { false && <>
          <button
            className="button is-outlined inline float-right"
            onClick={ () => dispatch(editorAddField(MeetingPageFieldType.RADIO)) }
          >
            <i className="fa fa-plus" />
            Add Radio
          </button>

          <button
            className="button is-outlined inline float-right"
            onClick={ () => dispatch(editorAddField(MeetingPageFieldType.NUMBER)) }
          >
            <i className="fa fa-plus" />
            Add Number
          </button>

          <button
            className="button is-outlined inline float-right"
            onClick={ () => dispatch(editorAddField(MeetingPageFieldType.SELECT)) }
          >
            <i className="fa fa-plus" />
            Add Select
          </button>
        </> }
      </div>
      <div>
        { fields.filter((field) => (
          field.type === MeetingPageFieldType.EMAIL 
          || field.type === MeetingPageFieldType.NAME 
          || field.type === MeetingPageFieldType.TEXT 
          || field.type === MeetingPageFieldType.RADIO
          || field.type === MeetingPageFieldType.NUMBER 
          || field.type === MeetingPageFieldType.SELECT
        )).map((field) => (
          <div className="field" key={ field.id }>
            <div className="field_top">
              <div>
                <span className="field_type">{ field.type }</span>
              </div>

              { field.type !== MeetingPageFieldType.EMAIL && field.type !== MeetingPageFieldType.NAME && 
              <div className="field_required">
                <span>{ strings.required + ': ' }</span>
                <CheckBox
                  selected={field.required}
                  onToggle={() => dispatch(editorToggleRequired(field.id)) }
                />
              </div>
              }
            </div>

            { getFieldContent(field) }

            <div className="field_bottom">
              { field.type === 'text' &&
                <button
                  className="underlined"
                  onClick={ () => dispatch(editorRemoveField(field.id)) }
                >
                  { strings.remove }
                </button>
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MeetingPageFields